import { UIDStoreBodyController } from './UIDStoreBodyController.ts';
import { UIWStoreController } from './UIWStoreController.ts';
import { sendStoreTabsClickedAnalytic } from '../../../shared/scripts/analytics/sendStoreTabsClickedAnalytic.ts';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIDStoreController extends UIWStoreController {
    createBodyController() {
        return new UIDStoreBodyController(this.storeState);
    }
    // eslint-disable-next-line class-methods-use-this
    shouldSetupCoinSectionVisibility() {
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    setupSidebarTabAnalytics() {
        const storeContainer = document.getElementById('scene_discord_store_container');
        if (storeContainer == null) return;
        const sidebarButtons = storeContainer.querySelectorAll('.singleton_page_sidebar_button');
        sidebarButtons.forEach((button)=>{
            const hash = button.getAttribute('href');
            if (hash == null) return;
            const tabName = hash.replace('#', '');
            setElementOnClick(button, ()=>sendStoreTabsClickedAnalytic(tabName));
        });
    }
}
